/**
 * Attributes that stop browsers and password-manager extensions from filling
 * the signed-in user's own PrintRun login into settings forms (their email
 * into an id field, their password into an API key / secret field).
 *
 * The data-* attributes opt out of 1Password, LastPass, Bitwarden and
 * Dashlane respectively. Spread these AFTER any caller props so a caller
 * cannot quietly put an autofill-friendly value back.
 */
const PASSWORD_MANAGER_IGNORE = {
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-bwignore': 'true',
  'data-form-type': 'other',
} as const;

/**
 * For masked secret inputs (API keys, client secrets, tokens). Use the
 * `SecretInput` primitive rather than spreading this directly where you can.
 *
 * Chrome ignores autocomplete="off" on password inputs. "new-password" stops
 * the fill but makes Chrome offer "Suggest strong password" and later
 * "Save password?". Chrome's form parser treats "one-time-code" as not a
 * password (IsNotPasswordField), so it fills nothing, username included, and
 * never suggests or saves one.
 */
export const secretAutofillProps = {
  autoComplete: 'one-time-code',
  ...PASSWORD_MANAGER_IGNORE,
} as const;

/**
 * For the plain text field that sits next to a secret (client ID, app ID,
 * base URL). Give that field an id/name that does not read as "user",
 * "login" or "email" too.
 */
export const noAutofillProps = {
  autoComplete: 'off',
  ...PASSWORD_MANAGER_IGNORE,
} as const;
